var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "form",
      [
        _c("ValidationObserver", {
          ref: "observer",
          attrs: { tag: "form" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ valid }) {
                return [
                  _c(
                    "b-field",
                    { attrs: { label: "Template name" } },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: { required: true } },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c("b-input", {
                                    model: {
                                      value: _vm.template.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.template, "name", $$v)
                                      },
                                      expression: "template.name",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Subject" } },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: { required: true } },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c("b-input", {
                                    model: {
                                      value: _vm.template.subject,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.template, "subject", $$v)
                                      },
                                      expression: "template.subject",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Sender" } },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: { required: true } },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c("b-input", {
                                    model: {
                                      value: _vm.template.sender,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.template, "sender", $$v)
                                      },
                                      expression: "template.sender",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("p", { staticClass: "control" }, [
                        _c("span", { staticClass: "button is-static" }, [
                          _vm._v("@fr-gps.com"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Language" } },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: { required: true } },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c(
                                    "b-select",
                                    {
                                      attrs: {
                                        placeholder:
                                          "select a mail display language",
                                      },
                                      model: {
                                        value: _vm.template.lang,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.template, "lang", $$v)
                                        },
                                        expression: "template.lang",
                                      },
                                    },
                                    _vm._l(_vm.langs, function (lang) {
                                      return _c(
                                        "option",
                                        {
                                          key: lang,
                                          domProps: { value: lang },
                                        },
                                        [_vm._v(" " + _vm._s(lang) + " ")]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Content" } },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: { required: true } },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _c("b-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.template.content,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.template, "content", $$v)
                                      },
                                      expression: "template.content",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Comment" } },
                    [
                      _c("b-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.template.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.template, "comment", $$v)
                          },
                          expression: "template.comment",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    { staticClass: "control buttons level-right" },
                    [
                      _c("b-button", {
                        attrs: { label: "Cancel" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("on-close")
                          },
                        },
                      }),
                      _c("b-button", {
                        staticClass: "button is-primary",
                        attrs: {
                          label: "Save",
                          disabled: !valid,
                          type: "submit",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }